import Error from 'components/Error/Error';
import Success from 'components/Success/Success';
import {useGlobalState} from 'hooks/useGlobalState';
import './Message.scss';

const Message = () => {
  const {success, error} = useGlobalState((state) => state.app);

  return (
    <div>
      {success && <Success success={success} />}
      {error && <Error error={error} />}
    </div>
  );
};

export default Message;
